import {
  HomeState,
  HomeAction,
  HEALTH_RISKS_LOADED,
  OVERVIEW_LOADED,
  RETENTION_LOADED,
  ENERGY_LOADED,
} from "./types";

const initialState: HomeState = {
  healthRisks: {
    cvd: [],
    msd: [],
    metabolic: [],
    sad: [],

    anxiety: [],
    depression: [],
    obesity: [],
    stress: [],
    t2d: [],
  },

  overview: {
    conversion: [],
    lqi: [],
    retention: [],
    roi: [],
  },

  retention: {
    appreciated: [],
    challenged: [],
    empowered: [],
    flexible: [],
    involved: [],
    mentored: [],
    onMission: [],
    paidWell: [],
    promoted: [],
    trusted: [],
    valued: [],
  },

  energy: [],
};

export function healthRisks(
  state = initialState,
  action: HomeAction
): HomeState {
  switch (action.type) {
    case HEALTH_RISKS_LOADED:
      return {
        ...state,
        healthRisks: action.healthRisks,
      };
    case OVERVIEW_LOADED:
      return {
        ...state,
        overview: action.overview,
      };
    case RETENTION_LOADED:
      return {
        ...state,
        retention: action.retention,
      };
    case ENERGY_LOADED:
      return { ...state, energy: action.energy };
    default:
      return state;
  }
}
